import { useRef, useEffect, MutableRefObject } from 'react';

/**
 * 呼び出し元のComponentがマウントされているかどうかをcurrentに持つrefを取得する
 *
 * `Warning: Can't perform a React state update on an unmounted component.` への対応で使う
 * {@see https://www.debuggr.io/react-update-unmounted-component/#bonus-tip}
 */
export const useIsMountedRef = (): MutableRefObject<boolean | null> => {
  const isMountedRef = useRef<boolean | null>(null);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  return isMountedRef;
};
